import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { homeArea, storedUser } from '../utils/dashboard-access';

export const guestGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);

  // A stored user without access to either dashboard (e.g. a role was removed) can log in again.
  if(homeArea(storedUser())) {
    router.navigate(['/'])
    return false;
  } else {
    return true;
  }
};
